import { View } from 'react-native';

import { LegalSection } from '@/components/domain/LegalSection';
import { BoundedScrollView } from '@/components/ui/BoundedScrollView';
import { NavBar } from '@/components/ui/NavBar';
import { Screen } from '@/components/ui/Screen';
import { Text } from '@/components/ui/Text';
import { useGoBack } from '@/lib/navigation';

const SECTIONS = [
  {
    index: '01',
    label: 'The basics',
    body: "You're responsible for the checklists you create and the runs you complete. Remove Before Flight is a tool for tracking work, not a substitute for required safety or compliance procedures.",
  },
  {
    index: '02',
    label: 'Your content',
    body: 'Your templates and run logs belong to you. We store them to sync across your devices and to share runs you choose to share. You can export or delete them at any time.',
  },
  {
    index: '03',
    label: 'Subscriptions',
    body: 'Pro is billed through the App Store. A free trial converts to a paid plan unless cancelled at least 24 hours before it ends. Manage or cancel anytime in Settings.',
  },
  {
    index: '04',
    label: 'Acceptable use',
    body: "Don't use the service to break the law, abuse other people you run with, or attempt to disrupt the platform for everyone else.",
  },
];

export default function TermsScreen() {
  const goBack = useGoBack('/');
  return (
    <Screen edges={['top']}>
      <NavBar onBack={goBack} title="Terms of Service" />
      <BoundedScrollView contentContainerClassName="gap-5 px-5 pb-10 pt-2">
        <Text variant="accent">Updated May 2026</Text>
        {SECTIONS.map((s) => (
          <LegalSection key={s.index} {...s} />
        ))}
        <View className="h-4" />
      </BoundedScrollView>
    </Screen>
  );
}
